import {
	IS_PIN_ENABLED_KEY,
	PIN_SETUP_LOGIN_SESSION_KEY,
	PIN_UNLOCK_LOGIN_SESSION_KEY,
} from '../assets/constants'

const PIN_SETUP_TOKEN_KEY = 'tick2trade_pin_setup_token'

function setBoth(key: string, value: string) {
	if (typeof sessionStorage !== 'undefined') sessionStorage.setItem(key, value)
	if (typeof localStorage !== 'undefined') localStorage.setItem(key, value)
}

function removeBoth(key: string) {
	if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(key)
	if (typeof localStorage !== 'undefined') localStorage.removeItem(key)
}

function getEither(key: string): string | null {
	if (typeof sessionStorage !== 'undefined') {
		const s = sessionStorage.getItem(key)
		if (s !== null) return s
	}
	if (typeof localStorage !== 'undefined') {
		return localStorage.getItem(key)
	}
	return null
}

export function isPinEnabledFlag(): boolean {
	return getEither(IS_PIN_ENABLED_KEY) === '1'
}

export function setPinEnabledFlag(enabled: boolean) {
	setBoth(IS_PIN_ENABLED_KEY, enabled ? '1' : '0')
}

export function applyPinEnabledFromUserProfile(user: unknown) {
	if (!user || typeof user !== 'object') return
	const o = user as Record<string, unknown>
	const v = o.isPinEnabled ?? o.is_pin_enabled
	if (typeof v === 'boolean') {
		setPinEnabledFlag(v)
	}
}

export function isPinUnlockPending(): boolean {
	return getEither(PIN_UNLOCK_LOGIN_SESSION_KEY) === '1'
}

export function setPinUnlockPending() {
	setBoth(PIN_UNLOCK_LOGIN_SESSION_KEY, '1')
}

export function clearPinUnlockPending() {
	removeBoth(PIN_UNLOCK_LOGIN_SESSION_KEY)
}

export function isPinSetupPending(): boolean {
	return getEither(PIN_SETUP_LOGIN_SESSION_KEY) === '1'
}

/** @deprecated Setup is in-app; kept for clearing legacy flags. */
export function setPinSetupPending() {
	setBoth(PIN_SETUP_LOGIN_SESSION_KEY, '1')
}

export function clearPinSetupPending() {
	removeBoth(PIN_SETUP_LOGIN_SESSION_KEY)
}

/** True when login page must stay open for PIN unlock only. */
export function isPinAuthGatePending(): boolean {
	return isPinUnlockPending()
}

export function setPinSetupToken(token: string) {
	if (typeof sessionStorage !== 'undefined') {
		sessionStorage.setItem(PIN_SETUP_TOKEN_KEY, token)
	}
}

export function getPinSetupToken(): string | null {
	if (typeof sessionStorage === 'undefined') return null
	return sessionStorage.getItem(PIN_SETUP_TOKEN_KEY)
}

export function clearPinSetupToken() {
	if (typeof sessionStorage !== 'undefined') {
		sessionStorage.removeItem(PIN_SETUP_TOKEN_KEY)
	}
}

export function clearPinBrowserFlags() {
	removeBoth(IS_PIN_ENABLED_KEY)
	removeBoth(PIN_UNLOCK_LOGIN_SESSION_KEY)
	removeBoth(PIN_SETUP_LOGIN_SESSION_KEY)
	clearPinSetupToken()
}
